import React, { FC, useRef } from "react";
import { useFormContext } from "react-hook-form";

import StyledFormInput from "./FormInput";
import CustomNumericFormat from "./NumericFormat";

import { InputEvent, NumericTextInputProps } from "./types";

const StyledFormNumericInput: FC<NumericTextInputProps> = (props) => {
  const { maxValue, decimalScale, ...rest } = props;

  const inputRef = useRef<HTMLInputElement>(null);
  const { setValue } = useFormContext();

  const onChange = ({ target }: InputEvent) => {
    setValue(props.name, target.value);
  };

  return (
    <StyledFormInput
      defaultValue=""
      inputRef={inputRef}
      rules={{
        onChange,
      }}
      slotProps={{
        input: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          inputComponent: CustomNumericFormat as any,
          inputProps: {
            inputMode: "decimal",
            decimalScale: decimalScale ?? 2,
            maxValue,
          },
        },
      }}
      {...rest}
    />
  );
};

export default StyledFormNumericInput;
